import { formatAgeRange } from '~shared/helpers/datetime';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '~shared/shadcn/ui/alert-dialog';

interface AgeRangeWarningDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  studentName: string;
  studentAge: {
    years: number;
    months: number;
  };
  classAgeRange: {
    startYear: number;
    startMonth: number;
    endYear: number;
    endMonth: number;
  };
  entityType?: 'class' | 'event';
  confirmLabel?: string;
  proceedMessage?: string;
}

export function AgeRangeWarningDialog({
  open,
  onOpenChange,
  onConfirm,
  studentName,
  studentAge,
  classAgeRange,
  entityType = 'class',
  confirmLabel = 'Proceed with Enrollment',
  proceedMessage = 'Do you want to proceed with enrollment anyway?',
}: AgeRangeWarningDialogProps) {
  const formatAge = (years: number, months: number) => {
    return `${years} ${years !== 1 ? 'years' : 'year'} ${months} ${months !== 1 ? 'months' : 'month'}`;
  };

  const ageRangeText = formatAgeRange(
    classAgeRange.startYear,
    classAgeRange.startMonth,
    classAgeRange.endYear,
    classAgeRange.endMonth,
  );
  const studentAgeText = formatAge(studentAge.years, studentAge.months);
  const entityLabel = entityType === 'class' ? 'Class' : 'Event';

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Age Range Warning</AlertDialogTitle>
        </AlertDialogHeader>
        <div className='space-y-2 text-sm text-muted-foreground'>
          <p>
            <strong className='text-foreground'>{studentName}</strong> is{' '}
            <strong className='text-foreground'>{studentAgeText}</strong> old,
            which is outside the recommended age range for this {entityType}.
          </p>
          <p>
            {entityLabel} age range:{' '}
            <strong className='text-foreground'>{ageRangeText}</strong>
          </p>
          <p>{proceedMessage}</p>
        </div>

        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
